import { getSettlement, postTaxPdf } from "crud/auth.crud";
import React, { useState, useEffect, Fragment } from "react"
import axios from "axios";

import { Link, useLocation } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"
import { useSelector } from "react-redux";

import moment from "moment";
import Util from "pages/Dashboard/Common/Util";
import loading from "../../assets/images/loading.gif";
import Modal from "components/RopikCustom/Modal_v2";
import Pagination from "pages/Custom/Pagination";

const selectedClass = 'secondary-bg white-text border-none'
const unselectedClass = 'button-border secondary-text white-bg'

const CollectionPaymentTable = ({ listCount, setListCount }) => {
  const selector = useSelector(state => state)
  const location = useLocation()

  const [dataList, setDataList] = useState([])
  const [modalShow, setModalShow] = useState(false)
  const [detailData, setDetailData] = useState()
  const [page, setPage] = useState(1)
  const [isLoading, setIsLoading] = useState(false);
  const [pagesGroup, setPagesGroup] = useState(1);  
  const [pageArr, setPageArr] = useState([pagesGroup, pagesGroup + 1, pagesGroup + 2, pagesGroup + 3, pagesGroup + 4]);
  const [contentCount, setContentCount] = useState();
  const [pdfUrl, setPdfUrl] = useState();
  const [isListEnd, setIsListEnd] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  const getDataList = async () => {
    setIsLoading(true)
    const params = {
      page: page,
      company: location.state?.company?.id,
      collection_company: selector.auth?.user?.member_group?.[0]?.company_group?.id
    }

    let url = '/payment_report/data_to_list/?page=' + params.page + '&company=' + params.company + '&type=collect&company_from=' + params.collection_company;
    const response = await getSettlement(url);      
    if (response.status === 200) {
      const content = response.data?.results || [];
      if (content.length > 0) {
        setDataList([...dataList, ...content])
        setListCount(response.data?.count || 0)
        setPage(page + 1)
      }else{
        setIsListEnd(true)
      }
    }

    setIsLoading(false)
  }

  const saveTaxBill = async (str) => {
          
    setIsLoading(true)
    
    const toDate = moment(new Date()).format('YYYYMMDDhhmmss');
    const mgtKey = toDate + '-' + detailData?.id;

    const fromRs = await fromRsData(detailData?.company_from.id);
    const fromData = fromRs.data || {}

    const toRs = await toRsData(detailData?.company_to.id);
    const toData = toRs.data || {}
    
    const params = {
      payment_report_id : detailData?.id,
      company_from_number : fromData.company_number,
      company_from_name : fromData.name,
      company_from_user_name : fromData.username,
      company_from_address : fromData.address1 + fromData.address2,
      company_from_email : fromData.email,
      company_from_phone : fromData.phone,
      company_from_mobile : fromData.mobile_phone,
      company_from_type : fromData.type,
      company_from_sector : fromData.type,
      company_to_number : toData.company_number,
      company_to_name : toData.name,
      company_to_user_name : toData.username,
      company_to_address : toData.address1 + toData.address2,
      company_to_email : toData.email,
      company_to_phone : toData.phone,
      company_to_mobile : toData.mobile_phone,
      company_to_fax : toData.fax,
      company_to_type : toData.type,
      company_to_sector : toData.type,
      price : parseInt(detailData?.payed_price * (10 / 11)),
      vat : detailData?.payed_price - parseInt(detailData?.payed_price * (10 / 11)),
      total_price : detailData?.total_payment_price,            
      mgt_key : mgtKey,
      mgt_date : toDate,
      taxbill_type : str
    }
    
    const response = await registTaxBill(params)
    setIsLoading(false)
  }

  const modalClose = () => {
    setModalShow(false)
  }

  const clickList = async (item) => {
    const params = {
      id: item.id
    }
    const rs = await postTaxPdf(params);
    setDetailData(item);
    setModalShow(true)
    setPdfUrl(rs.data?.data || '')
  }

  const downloadPdf = () => {
    const url = pdfUrl;
    const win = window.open(url, '_blank');
    win.focus();
  };

  useEffect(() => {
    getDataList()
  }, [page])
  
  return (
    <Fragment>
      <div className="email-rightbar mb-3">
        <Card>
          <CardBody style={{ padding: 0, borderRadius: 4, overflowX: 'hidden', overflowY: 'hidden', height: 806 }}>
            <div className="table-responsive" id={"sc-body"} style={{maxHeight: 660}} style={{ padding: 0, overflowX: 'hidden', overflowY: 'auto', height: 806 }}>
              <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
                <thead className="chart-thead">
                  <tr>
                    <th scope="col">No</th>
                    <th scope="col">고지년월</th>
                    <th scope="col">고지서발행일자</th>
                    <th scope="col">납부일자</th>
                    <th scope="col">수거량(ℓ)</th>
                    <th scope="col">정산금액(원)</th>
                    <th scope="col">납부여부</th>
                    <th scope="col">세금계산서 발행</th>
                  </tr>
                </thead>
                <tbody className="chart-tbody clickable">

                  {dataList.map((item, index) => {
                    return (
                      <tr className="pointer" key={item.id + '_' + index}>
                        <td className="pointer" >{listCount - index}</td>
                        <td className="pointer"  >{moment(item.report_date).format('YYYY-MM') || ''}</td>
                        <td className="pointer"  >{moment(item.report_date).format('YYYY-MM-DD') || ''}</td>
                        <td className="pointer"  >{item.payment_date ? moment(item.payment_date).format('YYYY-MM-DD') : ''}</td>
                        <td className="pointer"  >{Util.setCommaPrice((item.contract?.collect_type == 'l' ? item?.total_qty_l : item?.qty_total_qty) || 0)}</td>
                        <td className="pointer"  >{Util.setCommaPrice(item.total_price || 0)}</td>                                          
                        <td>{item.state === 'Y' ? '완납' : item.state === 'N' ? '미납' : '부분납부'}</td>
                        <td className="click-not">
                          <button style={{ width: 199, height: 29 }} type="button" className={`custom-btn border-radius-0 margin-right-4 font-size-15 line-height-1 ${item.state === 'Y' ? unselectedClass : selectedClass}`} onClick={(e) => {
                            e.stopPropagation()
                            clickList(item)
                          }}>
                            세금계산서 청구서 작성
                          </button>
                        </td>
                      </tr>
                    )
                  })}
                  {dataList.lenght === 0 &&
                    <tr>
                      <td scope="row" colSpan="6">데이터가 없습니다.</td>
                    </tr>
                  }

                </tbody>
              </table>
            </div>
          </CardBody>
          {isLoading && <div style={{
            position: "absolute",
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            background: 'rgba(255, 255, 255, 0.6)',
            zIndex: 999,
            display: "flex",
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <img src={loading} alt="로딩중입니다." width={'7%'}></img>
          </div>}
        </Card>
      </div>

      <Modal title={'고지 상세 내역'} show={modalShow} onHide={modalClose} size="md"
      bodyChildren={
        <Fragment>
        <table className="input-table">
          <tbody>
            {console.log(detailData)}
            <tr>
              <td className="w-20 padding-left-8 primary-bg white-text font-size-12">업체명</td>
              <td className="w-80">{detailData?.company_to?.name}</td>
            </tr>
            <tr>
              <td className="w-20 padding-left-8 primary-bg white-text font-size-12">당월 미정산액</td>
              <td className="w-80 text-end">{Util.setCommaPrice(detailData?.total_price)}</td>
            </tr>
            <tr>
              <td className="w-20 padding-left-8 primary-bg white-text font-size-12">이전 미정산액</td>
              <td className="w-80 text-end">{Util.setCommaPrice(detailData?.prev_price)}</td>
            </tr>
            <tr>
              <td className="w-20 padding-left-8 primary-bg white-text font-size-12">총 금액</td>
              <td className="w-80 text-end">{Util.setCommaPrice(detailData?.total_payment_price)}</td>
            </tr>
            <tr>
              <td className="w-20 padding-left-8 primary-bg white-text font-size-12">납부금액</td>
              <td className="w-80 text-end">{Util.setCommaPrice(detailData?.payed_price)}</td>
            </tr>
            <tr>
              <td className="w-20 padding-left-8 primary-bg white-text font-size-12">미납금액</td>
              <td className="w-80 text-end">{Util.setCommaPrice(detailData?.total_payment_price - detailData?.payed_price)}</td>
            </tr>
            <tr>
              <td className="w-20 padding-left-8 primary-bg white-text font-size-12">완납여부</td>
              <td className="w-80 text-end">{detailData?.state === 'Y' || detailData?.total_price === 0 ? '완납' : detailData?.state === 'N' && detailData?.total_price > 0 ? '미납' : '부분납부'}</td>
            </tr>
          </tbody>
        </table>
        </Fragment>
        }
        footerChildren={
        <div className="d-flex justify-content-between w-100">
          {detailData?.tax_state === 'Y' && detailData?.total_payment_price === detailData?.payed_price &&
            <button style={{width: 166, height: 27}} className="`custom-btn border-radius-0 margin-right-4 font-size-11 line-height-1 secondary-bg white-text border-none" onClick={() => {
              downloadPdf()
            }}>세금계산서 청구서 작성</button>
          }
          {detailData?.tax_state === 'D' && detailData?.total_payment_price !== detailData?.payed_price &&
            <button style={{width: 166, height: 27}} className="`custom-btn border-radius-0 margin-right-4 font-size-11 line-height-1 secondary-bg white-text border-none" onClick={() => {
              downloadPdf()
            }}>세금계산서 청구서 작성</button>
          }
          {detailData?.tax_state !== 'Y' && detailData?.total_payment_price === detailData?.payed_price &&
            <button style={{width: 166, height: 27}} className="`custom-btn border-radius-0 margin-right-4 font-size-11 line-height-1 secondary-bg white-text border-none" onClick={() => {
              saveTaxBill('영수')
            }}>세금계산서 영수증 작성</button>
          }
          {detailData?.tax_state === 'N' && detailData?.total_payment_price !== detailData?.payed_price &&
            <button style={{width: 166, height: 27}} className="`custom-btn border-radius-0 margin-right-4 font-size-11 line-height-1 secondary-bg white-text border-none" onClick={() => {
              saveTaxBill('청구')
            }}>세금계산서 청구서 작성</button>
          }
          <button style={{width: 59, height: 27}} className="custom-btn border-radius-0 font-size-11 line-height-1 button-border secondary-text white-bg margin-right-0" onClick={() => {
            setDetailData(null)
            modalClose()
          }}>확인</button>
        </div>
        }
      />
    </Fragment>
  )
}

export default CollectionPaymentTable
